import { render, staticRenderFns } from "./DetectionListMyRequestLayout.vue?vue&type=template&id=d02fffd4&scoped=true&"
import script from "./DetectionListMyRequestLayout.vue?vue&type=script&lang=js&"
export * from "./DetectionListMyRequestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d02fffd4",
  null
  
)

export default component.exports